(function() {
    angular
        .module("app")
        .controller("ShowApiKeyModalController", ShowApiKeyModalController)

        ShowApiKeyModalController.$inject = [
        "$state",
        "$scope",
        "$uibModalInstance",
        "key"
    ]

    function ShowApiKeyModalController(
        $state,
        $scope,
        $uibModalInstance,
        key
    ){
        "use strict"

        $scope.key = key

        $scope.close = function() {
            $uibModalInstance.dismiss("cancel")
        }
    }
})()
